import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../api/store";

export type policyDataPageModalType = null | "policyDataPageGCLIP";
export type policyType = null | 'GCLIP_PRIN' | 'GCLIP_OUT' | 'GPA_GADDP';

export interface PolicyDataPageState {
    policyNumber: string;
    policyModals: policyDataPageModalType;
    proposalId: null | number;
    typeOfPolicy: policyType;
    isForIssuancePolicy: {
        isIssuancePolicy: boolean;
        notesForPolicyApproval: string
    }
}

const initialState: PolicyDataPageState = {
    policyNumber: '',
    policyModals: null,
    proposalId: null,
    typeOfPolicy: null,
    isForIssuancePolicy: {
        isIssuancePolicy: false,
        notesForPolicyApproval: ''
    }
};

const policyDataPageSlice = createSlice({
    name: "policyDataPageSlice",
    initialState,
    reducers: {
        setIsForIssuancePolicy: (state, action: PayloadAction<Partial<typeof state.isForIssuancePolicy>>) => {
            state.isForIssuancePolicy = {
                ...state.isForIssuancePolicy,
                ...action.payload,
            };
        },
        setPolicyNumber: ( state, action: PayloadAction<string> ) => {
            state.policyNumber = action.payload;
        },
        setPolicyDataPageModalType: ( state, action: PayloadAction<policyDataPageModalType> ) => {
            state.policyModals = action.payload;
        },

        setPolicyType: ( state, action: PayloadAction<policyType> ) => {
            state.typeOfPolicy = action.payload;
        },
        
        setProposalIdForPolicy: ( state, action: PayloadAction<number | null> ) => {
            state.proposalId = action.payload;
        },

        resetPolicyDataPageState: () => initialState,
    },
});

export const {
    setIsForIssuancePolicy,
    setPolicyNumber,
    setPolicyDataPageModalType,
    setPolicyType,
    setProposalIdForPolicy,

    resetPolicyDataPageState
} = policyDataPageSlice.actions;

export default policyDataPageSlice.reducer;

export const selectPolicyNumber = (state: RootState) => state.policyDataPageSlice.policyNumber;
export const selectPolicyDataPageModalType = (state: RootState) => state.policyDataPageSlice.policyModals;
export const selectProposalIdForPolicy = (state: RootState) => state.policyDataPageSlice.proposalId;
export const selectPolicyType = (state: RootState) => state.policyDataPageSlice.typeOfPolicy;
export const selectIsIssuancePolicy = (state: RootState) => state.policyDataPageSlice.isForIssuancePolicy;